/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [],
        name: "PACKAGE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "moduleType",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "verify",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class PausableIsm__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(owner, overrides) {
        return super.deploy(owner, overrides || {});
    }
    getDeployTransaction(owner, overrides) {
        return super.getDeployTransaction(owner, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=PausableIsm__factory.js.map